import * as React from 'react'

import { action, makeObservable, observable } from 'mobx'
import { observer } from 'mobx-react'
import { classList } from 'react-classlist-helper'

import Localization from '~/client/src/shared/localization/LocalizationManager'
import { testWhiteImg } from '~/client/src/shared/utils/imageUtils'

interface IProjectLogoProps {
  /**
   * The URL of the project's logo. If not provided, a default logo will be used.
   */
  logoUrl?: string
  className?: string

  isLogoWhite?: boolean
  onLogoWasAnalyzedAsMostlyWhite?: (isMostlyWhite: boolean) => void
}

const defaultStxLogoUrl = '/static/icons/struxhub-favicon-white-bg.png'

@observer
export class ProjectLogo extends React.Component<IProjectLogoProps> {
  @observable private isLogoWhitish: boolean = false

  public constructor(props: IProjectLogoProps) {
    super(props)

    // Intentional loose check
    if (props.isLogoWhite != null) this.isLogoWhitish = props.isLogoWhite

    makeObservable(this)
  }

  @action.bound
  private setIsLogoWhitish(value: boolean) {
    this.isLogoWhitish = value

    const { isLogoWhite, onLogoWasAnalyzedAsMostlyWhite } = this.props

    // Intentional loose check
    if (isLogoWhite == null && onLogoWasAnalyzedAsMostlyWhite) {
      onLogoWasAnalyzedAsMostlyWhite(value)
    }
  }

  private async checkForWhitishLogo() {
    const currentProjectLogo = this.props?.logoUrl

    if (currentProjectLogo) {
      this.setIsLogoWhitish(await testWhiteImg(currentProjectLogo))
    } else {
      this.setIsLogoWhitish(false)
    }
  }

  public componentDidMount() {
    // Only check for whitish logo if not explicitly provided
    // Intentional loose check
    if (this.props.isLogoWhite == null) {
      this.checkForWhitishLogo()
    }
  }

  public componentDidUpdate(prevProps: Readonly<IProjectLogoProps>): void {
    // Intentional loose check
    if (
      this.props.isLogoWhite == null &&
      prevProps.logoUrl !== this.props.logoUrl
    ) {
      this.checkForWhitishLogo()
    }
  }

  public render() {
    const { logoUrl } = this.props
    return (
      <div
        className={classList({
          'project-logo': true,
          'whitish-logo bg-grey-scale-light': this.isLogoWhitish,
          [this.props.className]: !!this.props.className,
        })}
      >
        <img
          src={logoUrl || defaultStxLogoUrl}
          alt={Localization.translator.projectLogo}
        />
      </div>
    )
  }
}
